import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=54d2a71c&scoped=true"
import script from "./Candidate.vue?vue&type=script&lang=js"
export * from "./Candidate.vue?vue&type=script&lang=js"
import style0 from "./Candidate.vue?vue&type=style&index=0&id=54d2a71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2a71c",
  null
  
)

export default component.exports